import styled from 'styled-components'

export const ConfusedWrapper = styled.div`
  max-width: 842px;
  width: 100%;
  margin-top: ${(props) => (props.paddingTop ? '48px' : '0')};
  color: #1f1f1f;
`
